// extracted by mini-css-extract-plugin
module.exports = {"shopCard":"ShopCard_shopCard__cpWZx","logo":"ShopCard_logo__4v6Pt","imageWrapper":"ShopCard_imageWrapper__TBRJd","link":"ShopCard_link__1tIRj","name":"ShopCard_name__ixgta"};